export const newsletterStyles = `
/* Reset completo para el contenedor del newsletter */
.newsletter-container {
  padding: 0;
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
  background-color: #ffffff;
}

.newsletter-container * {
  box-sizing: border-box;
}

.newsletter-container table {
  border-collapse: separate;
  border-spacing: 0;
}

.newsletter-container p {
  line-height: inherit;
  margin: 0;
}

.newsletter-container a {
  text-decoration: none;
}

.newsletter-container img {
  display: block;
  border: 0;
}

.newsletter-container .desktop_hide,
.newsletter-container .desktop_hide table {
  display: none;
  max-height: 0px;
  overflow: hidden;
}

.newsletter-container .image_block img+div {
  display: none;
}

.newsletter-container sup,
.newsletter-container sub {
  font-size: 75%;
  line-height: 0;
}

.newsletter-container .border-right {
  border-radius: 0 15px 15px 0;
}

.newsletter-container .border-left {
  border-radius: 15px 0 0 15px;
  overflow: hidden;
}

@media (max-width: 620px) {
  .newsletter-container .border-right {
    border-radius: 0 0 15px 15px !important;
  }

  .newsletter-container .border-left {
    border-radius: 15px 15px 0 0 !important;
  }

  .newsletter-container .image_block div.fullWidth {
    max-width: 100% !important;
  }

  .newsletter-container .mobile_hide {
    display: none !important;
    min-height: 0;
    max-height: 0;
    max-width: 0;
    overflow: hidden;
    font-size: 0px;
  }

  .newsletter-container .row-content {
    width: 100% !important;
  }

  .newsletter-container .stack .column {
    width: 100% !important;
    display: block !important;
  }

  .newsletter-container .stack .column.gap {
    display: none !important;
  }

  .newsletter-container .desktop_hide,
  .newsletter-container .desktop_hide table {
    display: table !important;
    max-height: none !important;
  }

  /* Feb styles */
  .newsletter-container .row-3 .column-1 .block-1.heading_block td.pad,
  .newsletter-container .row-5 .column-2 .block-1.heading_block td.pad,
  .newsletter-container .row-6 .column-1 {
    padding: 20px 10px 5px !important;
  }

  .newsletter-container .row-3 .column-1 .block-1.heading_block h1 {
    font-size: 18px !important;
  }

  .newsletter-container .row-3 .column-1 .block-2.heading_block td.pad {
    padding: 0 10px 15px !important;
  }

  .newsletter-container .row-3 .column-1 .block-2.heading_block h1 {
    font-size: 16px !important;
  }

  .newsletter-container .row-5 .column-2 .block-3.button_block td.pad {
    padding: 10px 10px 20px !important;
  }

  .newsletter-container .row-5 .column-2 .block-3.button_block span {
    line-height: 21.6px !important;
  }

  .newsletter-container .row-6 .column-1 .block-1.paragraph_block td.pad>div,
  .newsletter-container .row-6 .column-1 .block-2.paragraph_block td.pad>div {
    font-size: 15px !important;
  }

  .newsletter-container .row-3 .row-content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .newsletter-container .row-4 .row-content {
    padding: 10px !important;
  }

  .newsletter-container .row-5 .row-content {
    padding: 5px 10px !important;
  }

  .newsletter-container .row-3 .column-1 {
    padding: 10px 20px !important;
  }

  .newsletter-container .row-4 .column-1 {
    padding: 0 0 5px !important;
  }

  .newsletter-container .row-5 .column-2 {
    padding: 0 10px 5px !important;
  }

  /* Mar styles */
  .newsletter-container .social_block.desktop_hide .social-table {
    display: inline-block !important;
  }

  .newsletter-container .row-2 .column-1 .block-1.heading_block td.pad {
    padding: 20px 10px 15px !important;
  }

  .newsletter-container .row-2 .column-1 .block-1.heading_block h1 {
    font-size: 20px !important;
  }

  .newsletter-container .row-4 .column-2 .block-1.heading_block td.pad {
    padding: 20px 10px 5px !important;
  }

  .newsletter-container .row-4 .column-2 .block-3.button_block td.pad {
    padding: 10px 10px 20px !important;
  }

  .newsletter-container .row-4 .column-2 .block-3.button_block span {
    line-height: 21.6px !important;
  }

  .newsletter-container .row-1 .row-content {
    padding: 0 !important;
  }

  .newsletter-container .row-2 .row-content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .newsletter-container .row-3 .column-1 .col-pad {
    padding: 0 0 5px !important;
  }

  .newsletter-container .row-4 .column-2 .col-pad {
    padding: 0 10px 5px !important;
  }

  .newsletter-container .row-5 .column-1 .col-pad {
    padding: 20px 10px !important;
  }

  /* Apr styles */
  .newsletter-container .row-2 .column-1 .block-3.paragraph_block td.pad,
  .newsletter-container .row-6 .column-1 .block-1.paragraph_block td.pad {
    padding: 10px 10px 20px !important;
  }

  .newsletter-container .row-2 .column-1 .block-2.heading_block td.pad {
    padding: 20px 10px 15px !important;
  }

  .newsletter-container .row-2 .column-1 .block-2.heading_block h1 {
    font-size: 34px !important;
  }

  .newsletter-container .row-3 .column-2 .block-2.button_block td.pad,
  .newsletter-container .row-4 .column-2 .block-2.button_block td.pad,
  .newsletter-container .row-5 .column-2 .block-2.button_block td.pad {
    padding: 10px !important;
  }

  .newsletter-container .row-3 .column-2 .block-2.button_block span,
  .newsletter-container .row-4 .column-2 .block-2.button_block span,
  .newsletter-container .row-5 .column-2 .block-2.button_block span {
    line-height: 21.6px !important;
  }

  .newsletter-container .row-6 .column-1 .col-pad {
    padding: 20px 10px !important;
  }

  /* May styles */
  .newsletter-container .row-2 .column-1 .block-3.heading_block h1 {
    font-size: 34px !important;
  }

  .newsletter-container .row-2 .column-1 .block-4.paragraph_block td.pad {
    padding: 10px 10px 20px !important;
  }
}
`
